import React from 'react';
import Mask from 'utils/src/mask';

import { Col, Row } from "components/Grid";
import { Content, Text, Label1 } from './styles';

//import Text from 'components/Text';

export default function BrokingSummary1({ data }) {

    const {
        idOperation,
        proponent,
        claimsTotal,
        annualGrossRevenue,
        cpfOrCnpj,
        typeRisk,
        effectiveDate,
        latestComplaints,
        retroactivity,
        typeInsurance,
        CRO,
        damageCaused
    } = data;

    return (
        <Content>
            <Row>
                <Col xs={12} sm={12} md={4}>
                    <Label1>COTACAO Nº</Label1>
                    <Text>{idOperation}</Text>

                    <Label1>TIPO DE SEGURO</Label1>
                    <Text>{typeInsurance}</Text>

                    <Label1>FATURAMENTO ANUAL</Label1>
                    <Text>{annualGrossRevenue ? annualGrossRevenue : "-" }
                    </Text>

                    <Label1>CONHECIMENTO DE RECLAMAÇÕES POSSÍVEIS</Label1>
                    <Text>{damageCaused}
                    </Text>

                </Col>
                <Col xs={12} sm={12} md={4}>
                    <Label1>PROPONENTE</Label1>
                    <Text>{proponent}</Text>

                    <Label1>SEGURADORA ANTERIOR</Label1>
                    <Text>{"-"}</Text>

                    <Label1>RECLAMAÇÕES SOFRIDAS - 5 ANOS</Label1>
                    <Text>{claimsTotal ? claimsTotal : "-"}</Text>

                    <Label1>DATA INICIO DE VIGÊNCIA</Label1>
                    <Text>{effectiveDate}</Text>


                </Col>
                <Col xs={12} sm={12} md={4}>

                    <Label1>CPF/CNPJ PROPONENTE</Label1>
                    <Text>{cpfOrCnpj.length > 12 ?  Mask.cnpj(cpfOrCnpj) : Mask.cpf(cpfOrCnpj)}</Text>

                    <Label1>CRO</Label1>
                    <Text>{CRO}</Text>

                    <Label1>RECLAMAÇÕES SOFRIDAS - ANO ANTERIOR</Label1>
                    <Text>{latestComplaints ? latestComplaints : "-"}</Text>

                    <Label1>RETROATIVADE</Label1>
                    <Text>{retroactivity}</Text>
                </Col>
            </Row>
            <Row>
                <Col md={12} sm={12}>
                    <Label1>TIPO DE RISCO</Label1>
                    <Text>{typeRisk}</Text>
                </Col>
            </Row>
        </Content>
    )
}